import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { CustomerStaff } from "src/model/class/general classes/customer-staff";
import { DeviceCardListStoreAction } from "src/components/shared-components/enum/enumStoreAction";
import { DeviceCardList } from "src/model/interface/device-card-list";
import { DeviceList } from "src/model/interface/device-list";

/**
 * Reseet device card state and unset key storage
 */
export const deviceCardUnsetKeyStorage = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_UNSET_KEY_STORAGE
);

/**
 * Action to start valid list population
 */
export const deviceCardStartPopulatateValidListAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_START_POPULATE_VALID_LIST
);

/**
 * Action to handle successfull loading of valid list from server
 */
export const deviceCardValidListSuccessfullLoadedAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_VALID_LIST_SUCCESSFULL_LOADED
);

/**
 * Action to skipped valid list population
 */
export const deviceCardSkippedPopulateValidListAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_SKIPPED_POPULATE_VALID_LIST
);

/**
 * Action to start error handling for valid list fopulation
 */
export const deviceCardListPopulateStartErrorHandlingAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_VALID_LIST_POPULATED_START_ERROR_HANDLING,
  props<{ error: HttpErrorResponse }>()
);

/**
 * Action to handle generic error valid list population
 */
export const deviceCardListErorGenericPopulationAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_VALID_LIST_ERROR_GENERIC_POPULATION
);

/**
 * Action end valid list population
 */
export const deviceCardValidListPopulatedAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_VALID_LIST_POPULATED,
  props<{ listCard: Array<DeviceCardList>; listDevices: Array<DeviceList>; listCardOwners: Array<CustomerStaff> }>()
);

/**
 * Action end valid list population with old, pre-existent data (after API error) OR empty array if there were none.
 */
export const deviceCardValidListPopulatedOldDataAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_VALID_LIST_POPULATED_WITH_OLD_DATA,
  props<{
    oldListCard: Array<DeviceCardList>;
    oldDeviceList: Array<DeviceList>;
    oldCardOwnerList: Array<CustomerStaff>;
  }>()
);

/**
 * Action to start the procdeure to add new code in valid list; this procedure may include insertion of a new cardOwner in cardOwnerList too
 */
export const deviceCardAddCodeInValidListStartAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_NEW_CODE_ADDITION_START,
  props<{ newDeviceCardValidListCode: DeviceCardList, currentCardOwnerList: Array<CustomerStaff> }>()
);

/**
 * Action to add new code and (possibly) cardOwner to, respectively, valid list and cardOwnerList.
 */
export const deviceCardAddCodeCardOwnerInValidListAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_ADD_NEW_CODE_AND_CARDOWNER,
  props<{ newDeviceCardValidListCode: DeviceCardList, newCardOwner: Array<CustomerStaff> }>()
);


/**
 * Action to edit existing code in valid list
 */
export const deviceCardEditExistingCodeInValidListAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_EDIT_CODE_VALID_LIST,
  props<{ updateDeviceCardValidListCode: DeviceCardList }>()
);

/**
 * Action to remove existing code from valid list; also, update cardOwner list if needed
 */
export const deviceCardRemoveCodeFromValidListAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_REMOVE_CODE_VALID_LIST,
  props<{ idDevice: number; code: string, IDCardOwner: number }>()
);

/**
 * Action to handle new guest data telegram
 */
export const deviceCardHandleNewGuestDataTelegramAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_HANDLE_NEW_GUEST_TELEGRAM,
  props<{ idDevice: number; guestDataTelegram: string }>()
);

/**
 * Action to start load and subscribee guest data addresses
 */
export const deviceCardStartLoadAndSubscribeGuestDataServerConfirmationAddressesAction =
  createAction(
    DeviceCardListStoreAction.DEVICE_CARD_LOAD_SUBSCRIBE_GUEST_DATA_SERVER_CONFIRMATION_ADDRESSES,
    props<{ listDevices: Array<DeviceList> }>()
  );

/**
 * Action complete load and subscribee guest data addresses
 */
export const deviceCardCompleteLoadAndSubscribeGuestDataServerConfirmationAddressesAction =
  createAction(
    DeviceCardListStoreAction.DEVICE_CARD_COMPLETE_SUBSCRIBE_GUEST_DATA_SERVER_CONFIRMATION_ADDRESSES
  );

/**
 * Action to skip subscribption for guest data and server configuramtion addresses because
 * mqtt not connected
 */
export const deviceCardCSkipSubscribeGuestDataServerConfirmationAddressesAction =
  createAction(
    DeviceCardListStoreAction.DEVICE_CARD_SKIP_GUEST_DATA_SERVER_CONFIRMATION_ADDRESSES
  );

/**
 * Action to handle invalid input guest data telegram
 */
export const deviceCardInvalidGuestDataTelegramAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_GUEST_DATA_TELEGRAM_INVALID
);

/**
 * Action to handle skip request to delete code because not existin in device
 * valid list
 */
export const deviceCardSkippedRemoveCodeRequestAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_SKIPPED_REMOVE_CODE_REQUEST
);

/**
 * Action to handle new server confirmation address
 */
export const deviceCardHandleNewServerConfirmationAddressAction = createAction(
  DeviceCardListStoreAction.DEVICE_CARD_SERVER_CONFIRMATION_ADDRESS_RECEIVED,
  props<{ idDevice: number; serverConfirmationTelegram: string }>()
);
